import type { Logger } from '../types/logger';

/**
 * This times async functions. Does not handle any exceptions.
 */
export async function logTiming<T>(
  logger: Logger,
  asyncFn: () => Promise<T>,
  asyncFnName: string,
): Promise<T> {
  return logTimingWithLevel('debug', logger, asyncFn, asyncFnName);
}


/**
 * Like logTiming, but at "info" log level.
 */
export async function logTimingInfo<T>(
  logger: Logger,
  asyncFn: () => Promise<T>,
  asyncFnName: string,
): Promise<T> {
  return logTimingWithLevel('info', logger, asyncFn, asyncFnName);
}

async function logTimingWithLevel<T>(
  level: 'debug' | 'info',
  logger: Logger,
  asyncFn: () => Promise<T>,
  asyncFnName: string,
): Promise<T> {
  const startTime: any = new Date();
  const result = await asyncFn();
  const duration = (new Date() as any) - startTime;
  logger[level](`logTiming: ${asyncFnName}: took ${duration} ms`);
  return result;
}
